export var Tab = function Tab() {
  return null;
};